// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import Text from "components/typography/Text";

// #####################################################

export const StyledText = styled(({ noWrap, ...props }) => <Text {...props} />)`
	line-height: 1.2rem;
	vertical-align: baseline;

	${({ noWrap }) =>
		noWrap &&
		css`
			text-wrap: nowrap;
			text-wrap-mode: nowrap;
		`}
`;

// #####################################################
